const ConnectWallet = () => {
  return (
    <div>
      <div>This is the page for connecting wallet</div>
    </div>
  );
};

export default ConnectWallet;
